import { render, staticRenderFns } from "./softwareStep01.vue?vue&type=template&id=b6f037ca&"
import script from "./softwareStep01.vue?vue&type=script&lang=js&"
export * from "./softwareStep01.vue?vue&type=script&lang=js&"
import style0 from "./softwareStep01.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports